import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'
import Lazyload from 'react-lazy-load'
import Testimonials from "./TestimonialsHome";
// import FloatingDiv from "./FloatingDiv"
import {Trans, useTranslation, useI18next} from 'gatsby-plugin-react-i18next';
import { useLocation } from '@reach/router';

const TeamChallenges = () => {
    const { t } = useTranslation();
    return (
    <>
        <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 soln-hero tc-1">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h1 className="font-weight-semibold hero-heading text-center">
                        <Trans>Promote Togetherness</Trans>
                    </h1>
                    <p className="hero-para font-weight-normal text-center no-br">
                        <Trans>Foster teamwork, collaboration and healthy competition <br/>with group fitness activities.</Trans>
                    </p>
                    <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <section className="position-relative pb-0 vfitsoln">
            <div className="dark-bg pb-5">
                <div className="d-flex m-d-block justify-content-center align-items-center container custom_container p0">
                    <div className="col-12 text-center section-pdn-1">
                        <div className="col-12 p-0">
                            <h2 className='font-weight-semibold py-2 section-heading mb-4 no-br'><Trans>Need a competitive edge to <br/>drive participation?</Trans></h2>
                            <p className='section-para font-weight-normal no-br'><Trans>Healthy competition with live leaderboards keeps <br/>teams motivated and engaged.</Trans></p>
                        </div>
                    </div>
                </div>
                <div className="m030">
                    <img className="img-responsive curvepath-img" alt="Team Challenges Road Map" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1699957341/VantageFit/2023/team_challenge-painpoint.webp`)} width="1375" height="621"/>
                    {/* https://res.cloudinary.com/vantagecircle/image/upload/v1696834120/VantageFit/2023/team-challenge-track.png */}
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="">
                <h2 className="section-heading section-heading-top font-weight-semibold text-center no-br"><Trans>Elevate your Fitness Journey</Trans></h2>
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Push Each Other to Work Harder</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Set collective milestones and watch your teams work together to achieve them.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Establish shared goals for your team.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Encourage teamwork towards achieving milestones.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Watch as the team pushes each other to work harder.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1699957342/VantageFit/2023/Team_Challenge-Push_each_other_to_Work_harder.webp`)} loading='lazy' alt="Push Each Other to Work Harder" width="478" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Team Leaderboard</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Track team rankings, celebrate top-performing teams, and foster a competitive yet collaborative environment.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Monitor team rankings with a dynamic leaderboard.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Celebrate top-performing teams to boost morale.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Foster healthy competition that fuels collaboration.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1708335680/VantageFit/2023/Team_leaderboard-team_challenges.webp`)} loading='lazy' alt="Team Leaderboard" width="489" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Diverse Activities</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>From relay races to group yoga sessions, pick challenges that resonate with your teams.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Offer variety of activities to ensure diverse engagement within your team.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Consider team building options such as relay races and group yoga sessions.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Tailor your choices to align with the preferences and dynamics of your specific teams.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1699957342/VantageFit/2023/Team_Challenge-Diverse_Activities.webp`)} loading='lazy' alt="Diverse Activities" width="456" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Inclusive for All</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Designed to ensure everyone, regardless of fitness level, can participate and contribute.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Crafted to include everyone, regardless of fitness level.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Ensures everyone can actively participate and contribute.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Designed for inclusivity, allowing all members to contribute effectively.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703069492/VantageFit/2023/Team_Challenge-Inclusive_For_All.webp`)} loading='lazy' alt="Inclusive for All" width="576" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="gray-gradient-bg section-pdn-1">
            <div className="container custom_container mx-auto relative">
                <div className="px-5">
                    <h2 className="section-heading text-center pt-0">
                    <Trans>Real people, real results</Trans>
                    </h2>
                    <p className="col-12 sub-para text-center f-400 mt-0 mb-5 pb-5">
                    <Trans>Vantage Fit speaks for itself, but our
                        customer reviews speak even louder.</Trans>
                    </p>
                    {/* <div className="col-lg-12 testimonialcarousel mb-0 p-5">
                        <div className="testi_profile">
                            <div className="testi_profile_image"><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1700137313/VantageFit/2023/elsa_Robertson.webp" alt="Elsa Robertson" className="max-w lozad" width="" height="" loading="lazy"/></div>
                            <div className="testi_profile_name p-4">
                                <h3 className="font-weight-bold text-center text-lg-left text-white mb-0">Elsa Robertson</h3>
                                <p className="font-weight-light text-center text-lg-left text-white mb-0">Human Resource Manager at SRS Medical, United States</p>
                            </div>
                        </div>
                        <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center ">
                            <div className="col-12 col-md-11 d-flex flex-column">
                                <p className="section-para text-center text-lg-left mb-0">The <span>Vantage Fit</span> app is an effective tool for corporate walking challenges, offering a range of features to help participants stay motivated and connected throughout the challenge.</p>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-lg-12 testimonialcarousel d-none d-md-flex mb-0 p-5">
                        <div className="testi_profile">
                            <div className="testi_profile_image"><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1700137313/VantageFit/2023/elsa_Robertson.webp" alt="Elsa Robertson" className="max-w lozad" width="218" height="218" loading="lazy"/></div>
                            <div className="testi_profile_name p-4">
                                <h3 className="font-weight-bold text-center text-lg-left text-white mb-0">Elsa Robertson</h3>
                                <p className="font-weight-light text-center text-lg-left text-white mb-0"><Trans>Senior Associate at Heidrick & Struggles, Australia</Trans></p>
                            </div>
                        </div>
                        <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center ">
                            <div className="col-12 col-md-11 d-flex flex-column">
                                <p className="section-para text-center text-lg-left mb-0"><Trans>The <span>Vantage Fit</span> app is an effective tool for corporate walking challenges, offering a range of features to help participants stay motivated and connected throughout the challenge.</Trans></p>
                            </div>
                        </div>
                    </div>
                    <div className="d-md-none d-block p-3" style={{ background: 'white', boxShadow: '1px 0px 20px rgba(0,0,0,0.3)', borderRadius: '25px' }}>
                        <div className="p-2" style={{ background: '#1d2227', borderRadius: '40px', display: 'grid', justifyContent: 'center' }}>
                            <img style={{ marginLeft: '0.5rem !important', marginTop: '0.5rem', marginBottom: '1rem' }} src="https://res.cloudinary.com/vantagecircle/image/upload/v1700218240/VantageFit/2023/elsa_Robertson.webp" alt="Elsa Robertson" className="mx-auto" width="218" height="218" loading="lazy"/>
                            <h3 className="font-weight-bold text-center text-white mb-0">Elsa Robertson</h3>
                            <p className="font-weight-light text-center text-white my-3">Senior Associate at Heidrick & Struggles, Australia</p>
                        </div>
                        <p className="section-para text-center text-lg-left my-4"><Trans>The <span>Vantage Fit</span> app is an effective tool for corporate walking challenges, offering a range of features to help participants stay motivated and connected throughout the challenge.</Trans></p>

                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative section-pdn-1 pl-0 pr-0">
            <div className="logo-container">
                <h2 className="section-heading mb-5 no-br clr50">FAQ</h2>
                <div id="accordion" className="">
                    <Card>
                        <Button id="faq1">
                        <Trans>How do we form teams for the challenge?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq1">
                            <CardBody>
                            <Trans>In Vantage Fit, team composition is typically managed by the admin, who is responsible for configuring teams based on the organization's HR-provided specifications and requirements, resulting in a highly personalized user experience.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq2">
                        <Trans>Can we customize the type of challenges for our teams?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq2">
                            <CardBody>
                            <Trans>Yes, we can customize the type of challenges for our teams. Vantage Fit offers a range of custom challenges for your personalized themes and goals.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq3">
                        <Trans>How do you ensure inclusivity in team challenges?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq3">
                            <CardBody>
                            <Trans>Challenges within Vantage Fit inherently promote inclusivity. Through custom challenges tailored to your organization's needs and fitness objectives, Vantage Fit ensures a specialized approach that fosters inclusiveness.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                </div>
            </div>
        </section>

        <section className="tc-btm ctabtm multi-activity hero-bg position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center">
                    <Trans>Ready to Unite your Teams with Fitness?</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5">
                    <Trans>Start your Team Challenge journey with Vantage Fit today.</Trans>
                    </p>
                    <div className="pl-0 pr-0 col-12 mt-4 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default TeamChallenges
